import { render, staticRenderFns } from "./intranetGoodsList.vue?vue&type=template&id=476c961e&scoped=true&lang=html"
import script from "./intranetGoodsList.vue?vue&type=script&lang=js"
export * from "./intranetGoodsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476c961e",
  null
  
)

export default component.exports